import { AxiosRequestConfig } from 'axios';

export const REQUEST_HEADER_NAME_REFERRER = 'x-referrer';

const requestHandler = (config: AxiosRequestConfig): AxiosRequestConfig => {
    const referrer = location.pathname + location.search;
    config.headers[REQUEST_HEADER_NAME_REFERRER] = referrer;
    return config;
};

export {
    requestHandler,
};
